var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkstation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 79,
    viewBox: "0 0 41 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.3464 60.2986L0.524414 69.8999L14.8121 78.0546H23.152L25.98 70.6389L17.3464 60.2986Z",
    fill: "#615A59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54207 67.3623L9.27242 67.5169L9.27052 68.4276C9.2686 68.9541 9.64283 69.5936 10.1034 69.8563C10.3366 69.9891 10.5545 69.9986 10.7061 69.9095C10.7042 69.9104 10.97 69.7586 10.97 69.7586C11.1206 69.6723 11.2137 69.4882 11.2137 69.2274L11.2156 68.3167L9.54207 67.3623Z",
    fill: "#615A59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8674 70.2899C10.5248 70.8762 9.73601 71.0593 9.10555 70.6988C8.47413 70.3383 8.24093 69.5718 8.58255 68.9855C8.92513 68.3993 9.71393 68.2162 10.3444 68.5757C10.9758 68.9371 11.21 69.7046 10.8674 70.2899Z",
    fill: "#232120"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36776 68.0332L8.0981 68.1888L8.0962 69.0995C8.09428 69.6251 8.46851 70.2644 8.92912 70.5282C9.16231 70.661 9.38016 70.6705 9.53178 70.5813C9.52986 70.5832 9.79567 70.4314 9.79567 70.4314C9.94632 70.3451 10.0394 70.161 10.0394 69.9002L10.0413 68.9895L8.36776 68.0332Z",
    fill: "#615A59"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8995 74.9868L22.6299 75.1424L22.6279 76.0531C22.626 76.5787 22.9993 77.2181 23.4609 77.4818C23.6941 77.6146 23.9119 77.6241 24.0635 77.5349C24.0616 77.5359 24.3274 77.3841 24.3274 77.3841C24.4781 77.2977 24.5712 77.1137 24.5712 76.8528L24.5731 75.9421L22.8995 74.9868Z",
    fill: "#615A59"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2263 77.9142C23.8837 78.5005 23.0949 78.6836 22.4644 78.324C21.833 77.9635 21.5998 77.197 21.9414 76.6107C22.284 76.0245 23.0728 75.8414 23.7042 76.2019C24.3347 76.5605 24.5679 77.3279 24.2263 77.9142Z",
    fill: "#232120"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7252 75.6575L21.4556 75.8121L21.4536 76.7228C21.4517 77.2484 21.826 77.8887 22.2866 78.1515C22.5198 78.2843 22.7376 78.2938 22.8892 78.2046C22.8873 78.2056 23.1531 78.0538 23.1531 78.0538C23.3038 77.9674 23.3968 77.7834 23.3978 77.5225L23.3997 76.6118L21.7252 75.6575Z",
    fill: "#615A59"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7179 66.5293L37.4482 66.6849L37.4463 67.5956C37.4444 68.1211 37.8186 68.7605 38.2792 69.0243C38.5124 69.1571 38.7303 69.1656 38.8819 69.0774C38.88 69.0793 39.1458 68.9275 39.1458 68.9275C39.2964 68.8412 39.3895 68.6571 39.3895 68.3963L39.3914 67.4855L37.7179 66.5293Z",
    fill: "#615A59"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0427 69.4572C38.7001 70.0434 37.9113 70.2265 37.2808 69.867C36.6494 69.5065 36.4162 68.74 36.7578 68.1537C37.1004 67.5675 37.8892 67.3843 38.5197 67.7448C39.1511 68.1044 39.3853 68.8709 39.0427 69.4572Z",
    fill: "#232120"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5435 67.2L36.2739 67.3546L36.272 68.2653C36.2701 68.7908 36.6443 69.4312 37.1049 69.694C37.3381 69.8268 37.5559 69.8363 37.7076 69.7471C37.7056 69.748 37.9714 69.5963 37.9714 69.5963C38.1221 69.5099 38.2152 69.3259 38.2152 69.065L38.2171 68.1543L36.5435 67.2Z",
    fill: "#615A59"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6778 64.199L39.6865 67.5468L37.3143 69.4005L37.3066 66.0536L39.6778 64.199Z",
    fill: "#8D8381"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3063 66.0535L37.314 69.4003L25.9886 75.8815L25.981 72.5347L37.3063 66.0535Z",
    fill: "#807775"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9815 72.5347L25.9892 75.8815L22.7582 77.2457L22.7505 73.8988L25.9815 72.5347Z",
    fill: "#726B69"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7505 73.8991L22.7582 77.2459L7.55699 68.5695L7.54932 65.2227L22.7505 73.8991Z",
    fill: "#615A59"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4769 55.5225L7.54932 65.2224L22.7505 73.8989L25.9815 72.5347L37.3068 66.0535L39.6781 64.1989L24.4769 55.5225Z",
    fill: "#A49896"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M21.4533 69.6381L27.0795 70.0697L17.9046 59.5425L16.9421 59.8394L10.626 63.4585L21.4533 69.6381Z",
    fill: "#615A59"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7155 64.7584L13.0581 58.1045V62.067L27.079 70.0699L24.7155 64.7584Z",
    fill: "#615A59"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6992 66.292L27.0798 70.0695L24.7163 64.758L31.3347 60.9805L33.6992 66.292Z",
    fill: "#B0A3A1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7155 64.7583L13.0581 58.1045L19.6765 54.3269L31.3339 60.9808L24.7155 64.7583Z",
    fill: "#A49896"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6309 61.1341L13.6206 59.4161V59.1201L16.6309 60.8381V61.1341ZM16.6309 61.413L13.6206 59.695V59.991L16.6309 61.709V61.413ZM16.6309 61.987L13.6206 60.2689V60.5649L16.6309 62.2829V61.987ZM16.6309 62.5609L13.6206 60.8429V61.1388L16.6309 62.8569V62.5609ZM16.6309 63.1358L13.6206 61.4178V61.7137L16.6309 63.4318V63.1358Z",
    fill: "#464140"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0785 28.7532L14.812 29.4637V57.1094L16.3224 57.9718L19.0785 28.7532Z",
    fill: "#615A59"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6545 56.0705L16.3228 57.9716V30.3259L19.6545 28.4238V56.0705Z",
    fill: "#807775"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3224 30.3262L14.812 29.4638L18.1438 27.5627L19.6542 28.4241L16.3224 30.3262Z",
    fill: "#A49896"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9874 40.8573L8.8833 31.0956V29.9382L25.9874 39.6999V40.8573Z",
    fill: "#615A59"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M40.475 32.5882L25.9868 40.8567V39.6994L40.475 31.4299V32.5882Z",
    fill: "#807775"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9874 39.6993L8.8833 29.9376L23.3715 21.6682L40.4756 31.4299L25.9874 39.6993Z",
    fill: "#A49896"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M13.2861 27.4248H16.3137L16.6323 25.5151L13.2861 27.4248Z",
    fill: "#615A59"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0677 13.8406L14.8013 14.5521V26.562L16.3117 27.4244L19.0677 13.8406Z",
    fill: "#615A59"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6438 25.5227L16.312 27.4247V15.4138L19.6438 13.5127V25.5227Z",
    fill: "#807775"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3117 15.4136L14.8013 14.5522L18.1331 12.6501L19.6435 13.5125L16.3117 15.4136Z",
    fill: "#A49896"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2916 17.1139L16.2026 15.3503V17.0484L19.2916 18.812V17.1139Z",
    fill: "#615A59"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2916 17.1141L16.2026 15.3506L19.5344 13.4495L22.6234 15.2121L19.2916 17.1141Z",
    fill: "#A49896"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M22.1336 26.4031L11.813 32.2933L23.5999 39.0202H27.1744L22.1336 26.4031Z",
    fill: "#615A59"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1737 39.02L14.8687 31.9971V29.5515L27.1737 36.5754V39.02Z",
    fill: "#615A59"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2644 32.4992L27.1733 39.3997V36.5755L39.2644 29.6741V32.4992Z",
    fill: "#807775"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1783 37.9186L14.1938 30.5077V29.3438L27.1783 36.7556V37.9186Z",
    fill: "#C0BCBB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9386 30.6357L27.1787 37.9185V36.7555L39.9386 29.4727V30.6357Z",
    fill: "#DBD7D6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1783 36.7555L14.1938 29.3437L26.9528 22.0618L39.9383 29.4727L27.1783 36.7555Z",
    fill: "#F0EBE6"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3232 12.4365L23.7266 8.17993L23.9992 8.2786L19.5255 13.444L16.3232 12.4365Z",
    fill: "#A49896"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5245 13.4442L20.7134 21.9128C20.843 22.8359 19.9544 23.5758 19.0562 23.2931L17.7885 22.8938L16.3232 12.4358L19.5245 13.4442Z",
    fill: "#615A59"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9917 7.60263L29.053 0.667969L31.4454 17.7077L19.384 24.6424L16.9917 7.60263Z",
    fill: "#807775"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7183 7.95269L28.5245 1.73901L30.7171 17.3577L19.911 23.5714L17.7183 7.95269Z",
    fill: "#1B1514"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5479 7.44129L28.6092 0.507568L29.0525 0.667897L16.9912 7.60256L16.5479 7.44129Z",
    fill: "#A49896"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9912 7.60243L19.3835 24.6422L18.9363 24.479L16.5479 7.44116L16.9912 7.60243Z",
    fill: "#615A59"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M24.3759 26.0037L18.0127 29.6351L22.9605 32.4593H27.4639L24.3759 26.0037Z",
    fill: "#C0BCBB"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4656 26.959L22.2021 23.9546L27.4656 20.9502L32.7291 23.9546L27.4656 26.959Z",
    fill: "#FECA85"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4651 32.4588L22.2017 29.4553V23.9541L27.4651 26.9585V32.4588Z",
    fill: "#B78351"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7288 29.4553L27.4653 32.4588V26.9585L32.7288 23.9541V29.4553Z",
    fill: "#E2B06D"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6902 25.689L24.4268 22.6846L25.4977 22.0728L30.7611 25.0771L29.6902 25.689Z",
    fill: "#B6703B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7609 27.3537L29.6899 27.9656V25.6888L30.7609 25.0769V27.3537Z",
    fill: "#91592F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkstation);
export default __webpack_public_path__ + "static/media/workstation.0557bed1f62c3eb5fa227b1a3f8a36c6.svg";
export { ForwardRef as ReactComponent };